import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-field',
  template: `
    <div class="col-{{field.isCol}}" *ngIf="field">
      <label>{{field.label}} <span *ngIf="field.isRequired" class="text-danger">*</span></label>
      <ng-container *ngIf="field.isText">
        <input class="input__field" type="text" [(ngModel)]="value" [placeholder]="field.placeholder" pInputText>
      </ng-container>
      <ng-container *ngIf="field.isDropdown">
        <p-dropdown class="custom-dropdown" [(ngModel)]="value" [options]="dropdownOptions[field.field]"
          placeholder="Selectionnez une {{field.label}}" emptyFilterMessage="Aucune {{field.label}} trouvée"
          optionLabel="label" optionValue="value" [filter]="true" [showClear]="true">
        </p-dropdown>
      </ng-container>
    </div>
  `,  
  styles: [`
:host ::ng-deep {
    // .custom-dropdown {width: 100% !important}

    .input__field { width: 100% !important}}

    :host ::ng-deep .ui-inputtext{ width: fit-content!important}
  `]
})
export class DynamicFieldComponent {
  @Input() field: any;
  @Input() dropdownOptions: any;
  value: any;
}
